import { prop } from '@ipfabric/utils/fp/prop';
import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import { array } from 'fp-ts';
import { flow } from 'fp-ts/lib/function';
import { createSelector } from 'reselect';
import { makeMemoizeObject } from 'utils/memoize/makeMemoizeObject';
import { createScopedSelector } from 'utils/react/scopedSelector';
import type { DeviceViewModel } from '../DeviceViewModel';

export const selectDetachedDeviceViewEntities: (
  s: DeviceViewModel,
) => DeviceViewEntityId[] = createScopedSelector(() =>
  createSelector(
    prop('deviceViewWindows'),
    flow(array.map(prop('id')), makeMemoizeObject()),
  ),
);
